<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">マイカレンダー</span>
          </div>
        </header>
        <div class="card-content scroll-box">
          <!-- カレンダー連携 -->
          <div class="message">
            <div class="message">
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>ユーザー</b>
                  </p>
                </div>
                <div class="tab-box-right" style="flex-wrap: wrap;">
                  <p>{{calUser.username}}</p>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>カレンダーの色</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <div style="display: flex;">
                    <input style="border: solid thin #ccc;" class="input" type="text" placeholder="入力がない場合はランダムになります。" v-model="color">
                    <input style="height: 35px;" type="color" v-model="color" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-field style="width: 100%">
            <div style="width: 48%; align: left">
              <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                キャンセル
              </button>
            </div>
            <div style="width: 5%;">
            </div>
            <div style="width: 48%; align: right">
              <button class="button is-primary is-fullwidth" @click="clickEditMyCalendar(); closeEditPage();">
                変更
              </button>
            </div>
          </b-field>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
// 外部関数
import {
  autoColor
} from '@/functions/balloonFunc'

export default {
  name: 'ModalUserCalendarSetting',
  computed: {
    ...mapState('auth', ['users', 'departments', 'positions', 'calendarSettings']),
    userCalendars () {
      let ret = []
      for (const u1 of this.users) {
        let flg = false
        for (const u2 of this.calendarSettings) {
          if (u1.user_hash === u2.calendar_user || u1.user_hash === u2.user) flg = true
        }
        if (!flg) ret.push(u1)
      }
      return ret
    }
  },
  data () {
    return {
      pk: null,
      user: null,
      userHash: null,
      calUser: null,
      color: null,
      isCardModalActive: false,
      timeList: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23
      ],
      weekdayList: [
        '月', '火', '水', '木', '金', '土', '日'
      ],
      optionsRemainder: {
        theme: 'snow',
        placeholder: '内容を入力...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }]]
        }
      },
    }
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    clickEditMyCalendar () {
      this.$store.dispatch('auth/updateUserCalendarSetting', {
        pk: this.pk,
        user: this.user.userHash,
        calendar_user: this.userHash,
        background_color: this.color,
        color: this.autoColor(this.color)
      })
        .then(() => {
          this.$store.dispatch('calendar/getSchedules', {
            year     : new Date().getFullYear(),
            month    : new Date().getMonth() + 1,
            day      : new Date().getDate(),
            category : 'week'
          })
          this.isCardModalActive = false
        })
    },
    closeEditPage () {
      this.isCardModalActive = false
    }
  }
}
</script>

<style lang='scss' scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
.btn-default-color{
  background: #f8f8f8;
}
.on_switch {
  background: #EE2C98;
  color: #ffffff;
}
.message {
  background: white;
}
.message::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  overflow-y: scroll;
  padding: 16px;
  margin-top: 16px;
}
.tab-box::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 30%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 70%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
.select_container {
  height: 272px;
  overflow: auto;
  border: 1px solid #dbdbdb;
  margin-bottom: 6px;
  border-radius: 3px;
}
.select_container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.description {
  font-size: 14px;
}
.select_list {
  margin: 16px 0 16px 32px;
  display: flex;
  align-items: center;
}
.patern_num {
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.ConnectingWord {
  font-size: 14px;
  margin: 6px;
}
.input_point {
  width: 64px;
}
.if_select {
  margin: 16px;
}
.close-wrapper {
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  margin-left: 16px;
  &:hover {
    opacity: 1;
    color: red;
  }
  .mdi-close {
    &:before {
      font-weight: bold;
    }
  }
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  top: 64px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  overflow: auto;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
.quote-list-wrapper {
  overflow-y: scroll;
  margin: 8px;
}
.quote-list-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;

}
.open-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.open-quote-btn {
  cursor: pointer;
}
.quote-list-content {
  table {
    margin: auto;
    font-size: 12px;
  }
  table th {
    padding: 4px;
  }
  table td {
    padding: 4px;
  }
}
.table-container {
  overflow-y: scroll;
}
.table-container::-webkit-scrollbar {
  width: 10px;
  height: 0px;
  visibility: hidden;
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.not-find-quote {
  font-size: 12px;
}
.quote-explain {
  font-size: 12px;
  margin-bottom: 16px;
}
.close-btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalUserCalendarSetting.vue